import {NavBarLogoImg} from "components/images/NavBarLogo/NavBarLogo.styles";
import Images from "config/Images";

interface NavBarLogoProps extends React.HTMLAttributes<HTMLImageElement>{

}

function NavBarLogo(props: NavBarLogoProps){
  const {...rest} = props;

  return (
    <NavBarLogoImg src={Images.benevvLogo} {...rest}/>
  )
}

export default NavBarLogo;
